import { render } from "./Portfolio.vue?vue&type=template&id=a6d68e54&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=a6d68e54&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d68e54"]])

export default __exports__